module.exports = __webpack_public_path__ + "static/johnakridgefbn.492f351a.png";


//////////////////
// WEBPACK FOOTER
// ./static/files/johnakridgefbn.png
// module id = 385
// module chunks = 35783957827783 114276838955818